import { Location } from '@angular/common';
import { ChangeDetectorRef, Directive, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { IDictionary } from '../interfaces/models/idictionary.model';
import { EntityState } from '../models/enums';
import { EventsService } from '../services/events.service';
import { formatHttpErrorMessage } from '../utils/http-error-message.util';

@Directive({
    selector: 'demo',
    standalone: false
})

export abstract class VisualCmptBaseComponent implements OnInit {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private _loading = false;

  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    if (this._loading === value) {
      return;
    }

    this._loading = value;
    this.changeDetectorRef.markForCheck();
  }

  initialDataLoaded = false;
  routerTree: UrlTree;
  isDirty: boolean = false;
  locationBack: string;
  modelViewState: EntityState = EntityState.View;

  protected numericRegex = /^-?\d*\,?\d*$/
  
  constructor(
    protected events: EventsService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected location: Location) {
  }

  ngOnInit() {
    this.routerTree = this.router.parseUrl(this.router.url);
    this.route.queryParams
      .subscribe(params => {
        if (params && params.locationBack) {
          this.locationBack = decodeURIComponent(params.locationBack);
        }
      });
  }

  ngAfterViewInit(): void {
  }

  ngAfterContentInit() {
  }

  scrollTo() {
    try {
      const tree = this.router.parseUrl(this.router.url);
      if (tree.fragment) {
        const element = document.querySelector("#" + tree.fragment);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
          //console.log(element);
        }
      }
    }
    catch (e) {
    }
  }

  clearRouterFragment() {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParamsHandling: "merge"
      });
  }

  onInitialDataLoadingComplete() {    
    this.initialDataLoaded = true;
  }

  canDeactivate() {
    return !this.isDirty || confirm('Есть несохраненные изменения, которые будут потеряны. Продолжить?');
  }

  close(): void {
    if (this.canDeactivate()) {
      this.isDirty = false;

      if (window.history.length > 1)
        this.location.back();
      else
        this.router.navigate(['/']);
    }
  }

  handleLoadError(err: any): Promise<never> {
    this.loading = false;
    this.showExceptionMessage('Загрузка', err);
    return Promise.reject(err);
  }

  showExceptionMessage(title: string, err: any) {
    const plain = formatHttpErrorMessage(err, err?.statusText ?? 'Ошибка');
    const lines = plain.split('\n').filter(Boolean);
    const message =
      lines.length > 1
        ? '<ul>' + lines.map((line) => '<li>' + line + '</li>').join('') + '</ul>'
        : plain;
    this.showEventMessage('error', title, message, true);
  }

  showErrorMessage(title: string, message: string) {
    this.showEventMessage('error', title, message);
  }

  showWarningMessage(title: string, message: string) {
    this.showEventMessage('warn', title, message);
  }

  showSuccessMessage(title: string, message: string) {
    this.showEventMessage('success', title, message);
  }

  showEventMessage(severity: string, title: string, message: string, sticky: boolean = false): void {
    this.events.broadcast('alert', { severity: severity, summary: title, detail: message, sticky: sticky });
  }

  public trackByFnDict(index, item: IDictionary) {
    return item.Id;
    //return index;
  }

  public stringToHslColor(str: string, saturation: number, lightness: number) {
    var hash = 0;
    str = str.toString();
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var h = hash % 360;
    return 'hsl(' + h + ', ' + saturation + '%, ' + lightness + '%)';
  }

  public calculateAvatarColor(name) {
    let saturation = 35;
    let lightness = 70;
    let textColor = lightness > 70 ? '#555' : '#fff';

    let hexColor = this.stringToHslColor(name, saturation, lightness);
    return hexColor;
  }
}
